import { render, staticRenderFns } from "./ModalSpend.vue?vue&type=template&id=296bd8b6&scoped=true"
import script from "./ModalSpend.vue?vue&type=script&lang=js"
export * from "./ModalSpend.vue?vue&type=script&lang=js"
import style0 from "./ModalSpend.vue?vue&type=style&index=0&id=296bd8b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "296bd8b6",
  null
  
)

export default component.exports